// src/api/registerUser.js
import axios from "axios";
import { toast } from "react-toastify";
import { serverUrl } from "utils/utils";

const registerUser = async ({ formData, navigate, location }) => {
  try {
    const res = await axios.post(`${serverUrl}/user/register`, {
      name: formData.name,
      email: formData.email,
      password: formData.password,
    });
    localStorage.setItem(`userToken`, res.data.token);
    if (res.data.success) {
      toast.success(res.data.message);
      setTimeout(() => {
        navigate("/");
        location.reload();
      }, 2000);
    } else {
      toast.error(res.data.message);
    }
  } catch (err) {
    throw err.response?.data || { error: "Unknown error" };
  }
};

export default registerUser;
